export const LOCAL_STORAGE_KEYS = {
    SHOW_DEMO_PRODUCTS_MODAL: 'show_demo_products_modal',
    PROCESSING_CAMPAIGN: 'processing_campaign',
    CAMPAIGNS_FILTERS: 'campaigns_filters'
};
